var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.states,"label":"State/Province","item-text":"name","item-value":"name","dense":"","outlined":"","disabled":(_vm.country == null) || (_vm.country === ''),"loading":_vm.isLoading},on:{"change":_vm.selectedState},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }